import React from 'react';
import { cn } from '../../lib/utils.ts';
import { fieldVariants } from './fieldStyles.ts';

type InputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  className?: string;
  selectOnFocus?: boolean;
};

export const Input = React.forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, selectOnFocus = false, onFocus, ...props },
  ref,
) {
  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    if (selectOnFocus) {
      const input = e.currentTarget;
      requestAnimationFrame(() => input.select());
    }
    onFocus?.(e);
  };

  return (
    <input
      ref={ref}
      {...props}
      onFocus={handleFocus}
      className={cn(fieldVariants(), className)}
    />
  );
});

export default Input;
